<div class="grid grid-cols-2 header">
  <div>
    <sl-icon-button (click)="back()" name="chevron-left" class="mr-3"></sl-icon-button>
    <sl-label size="large">{{account?.name}}</sl-label>
  </div>
  <span class="text-right">
    <sl-button [disabled]="!form.valid || form.pristine" size="small" type="primary" (click)="save()" i18n>Save changes</sl-button>
</span>
</div>
<form [formGroup]="form" *ngIf="initialized">
  <sl-label i18n="@@ResourceEditorView.Address">Address</sl-label>
  <sl-card>
    <div class="grid gap-y-4">
      <sl-radio-group formControlName="addressSource">
        <sl-radio value="Organization">
          <span i18n>Same as Organization</span>
          <sl-label size="small" color="light" *ngIf="organization">{{organization | address}}</sl-label>
        </sl-radio>
        <sl-radio value="Account">
          <span i18n>Defined by Employee</span>
          <sl-label size="small" color="light" *ngIf="account">{{account | address}}</sl-label>
        </sl-radio>
        <sl-radio value="WorkSchedule" i18n>Specific address</sl-radio>
      </sl-radio-group>
      
    </div>
    <ws-address-input formControlName="address" class="mt-4 ml-6"></ws-address-input>
  </sl-card>


  <sl-label class="mt-6" i18n="@@ResourceEditorView.WorkSchedule">Work schedule</sl-label>
  <sl-card>
    <div class="grid grid-cols-2 gap-y-4">
      <ws-work-day-editor class="col-start-1" title="Monday" i18n-title formControlName="monday"></ws-work-day-editor>
      <ws-work-day-editor class="col-start-1" title="Tuesday" i18n-title formControlName="tuesday"></ws-work-day-editor>
      <ws-work-day-editor class="col-start-1" title="Wednesday" i18n-title formControlName="wednesday">
      </ws-work-day-editor>
      <ws-work-day-editor class="col-start-1" title="Thursday" i18n-title formControlName="thursday"></ws-work-day-editor>
      <ws-work-day-editor class="col-start-1" title="Friday" i18n-title formControlName="friday"></ws-work-day-editor>
      <ws-work-day-editor class="col-start-1" title="Saturday" i18n-title formControlName="saturday"></ws-work-day-editor>
      <ws-work-day-editor class="col-start-1" title="Sunday" i18n-title formControlName="sunday"></ws-work-day-editor>
    </div>
    <sl-divider></sl-divider>
    <sl-checkbox formControlName="offOnPublicHolidays" i18n>Off on public holidays</sl-checkbox>
  </sl-card>


  <sl-label class="mt-6" i18n="@@ResourceEditorView.Absence">Absence</sl-label>
  <ws-exemption-editor formControlName="exemptions" (onChange)="form.markAsDirty()"></ws-exemption-editor>

  <sl-label class="mt-6" i18n="@@ResourceEditorView.Details">Details</sl-label>
  <sl-card>
    <div class="grid grid-cols-2">
      <sl-input [(ngModel)]="commission" [ngModelOptions]="{standalone:true}" step="1" max="100" min="0" size="small" type="number" label="Commission" i18n-label><sl-icon name="percent" slot="suffix"></sl-icon></sl-input>
    </div>
  </sl-card>

</form>

